"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferTimeDef = void 0;
exports.bufferTimeDef = {
    bboxes: 10,
    pointer: 10,
    zoom: 10,
    canvasResize: 10,
    callback: 50
};
